import { Pin } from "lucide-react";

import { Card } from "@/components/ui/Card";
import type { Announcement } from "@/data/types";
import { cn } from "@/lib/cn";
import { formatIst } from "@/lib/time";

const KIND_LABEL: Record<Announcement["kind"], string> = {
  general: "Notice",
  jummah: "Jummah",
  janaza: "Janaza",
  eid: "Eid",
  meeting: "Meeting",
  development: "Development",
};

const KIND_TONE: Record<Announcement["kind"], string> = {
  general: "text-muted",
  jummah: "text-masjidGreen",
  janaza: "text-clay",
  eid: "text-goldText",
  meeting: "text-masjidGreen",
  development: "text-masjidGreen",
};

export function AnnouncementCard({ a }: { a: Announcement }) {
  const date = a.postedAt?.toDate ? a.postedAt.toDate() : null;
  return (
    <Card>
      <div className="flex items-start justify-between gap-3">
        <div className={cn("label-eyebrow", KIND_TONE[a.kind])}>{KIND_LABEL[a.kind]}</div>
        {a.isPinned ? (
          <Pin size={14} className="text-goldText" aria-label="Pinned" />
        ) : null}
      </div>
      <h3 className="mt-1 font-serif text-lg text-ink">{a.title}</h3>
      <p className="mt-2 whitespace-pre-line text-sm leading-relaxed text-ink/80">
        {a.body}
      </p>
      <div className="mt-3 flex items-center gap-2 text-xs text-muted">
        {date ? <span>{formatIst(date, "d MMM yyyy, h:mm a")}</span> : <span>Just posted</span>}
        {a.authorName ? <span>· {a.authorName}</span> : null}
      </div>
    </Card>
  );
}
